export const ru = {
    'add-success': 'Продукт успешно добавлен',
    error: 'Произошла ошибка, повторите попытку'
};
